<template>
  <c-modal size="lg" title='Multi-analiza' v-model="open">
    <c-row class="u-pb-20 u-font-bold">
      <c-col>Request properties:</c-col>
    </c-row>
    <c-row>
      <div v-bind:key="p.property_code" v-for="p in props">
        <div v-if="p.allows_manual_input && p.is_visible">
          <c-col>{{p.property_display_name}} <i class="u-fs-12 u-color-grey-light">{{reqIndicator(p)}}</i>
          </c-col>
          <c-col>
            <c-form-input v-if="p.property_type === 'string'" v-model="propValues[p.property_code]"></c-form-input>
            <c-form-select :options="enumValues(p.property_type)" v-if="p.property_type.startsWith('enum')"
                           v-model="propValues[p.property_code]"></c-form-select>
          </c-col>
        </div>
      </div>
    </c-row>
    <c-row class="u-pb-20 u-pt-20 u-font-bold">
      <c-col>Files to upload:</c-col>
    </c-row>
    <c-scroll-view style="height:400px">
      <c-row :class="{'u-bg-grey-lightest': index % 2}" :key="file.id" align="middle" v-for="(file,index) in files">
        <c-col span="16">
          {{file.name}}
        </c-col>
        <c-col span="7">
          <c-form-select :options="requestRoles" v-model="file['role']"></c-form-select>
        </c-col>
        <c-col>
          <span v-if="file.error"><i class="icon-notification2 u-color-danger"
                                     v-tooltip="file.error"></i></span>
          <span v-else-if="file.success"><i class="icon-checkmark u-color-success"></i></span>
          <span v-else-if="file.active"><i class="i-spinner"></i></span>
          <span v-else>
          <a @click.prevent="$refs.multiproc_upload.remove(file)" href="#"><i class="icon-bin"></i></a>
                </span>
        </c-col>
      </c-row>
    </c-scroll-view>
    <c-row>
      <c-col></c-col>
    </c-row>
    <c-row>
      <c-col>
      </c-col>
    </c-row>
    <div class="u-text-right" slot="footer">
      <a class="u-fl" href="#" v-show="!is_uploading">
      <span class="i-text">
        <file-upload
          :accept="accept"
          :add-index="addIndex"
          :data="data"
          :directory="directory"
          :drop="drop"
          :drop-directory="dropDirectory"
          :extensions="extensions"
          :headers="headers"
          :multiple="multiple"
          :post-action="postAction"
          :put-action="putAction"
          :size="size || 0"
          :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
          @input-file="inputFile"
          @input-filter="inputFilter"
          class="btn btn-primary dropdown-toggle"
          ref="multiproc_upload"
          v-model="files">
            <i class="icon-plus"></i>
            Select files
        </file-upload>
      </span>
      </a>
      <c-button :disabled="is_uploading" @click="onContinue" type="primary">Continue</c-button>
      <c-button @click="onCancel">Close</c-button>
    </div>
  </c-modal>
</template>

<script>
  import {mapState} from 'vuex'
  import axios from 'axios'
  import batches from '../../../services/batches.service'

  export default {
    name: 'BatchMultiproc',

    components: [],

    computed: {
      ...mapState('auth', ['clientCode']),
      ...mapState('client', ['requestProperties'])
    },

    data () {
      return {
        open: false,
        props: [],
        propValues: {},
        onCompleteCallback: null,
        onCancelCallback: null,

        is_uploading: false,

        // for upload component
        files: [],
        accept:
          'application/pdf',
        extensions: 'pdf',
        minSize: 1,
        size: 1024 * 1024 * 30,
        multiple: true,
        directory: false,
        drop: true,
        dropDirectory: false,
        addIndex: true,
        thread: 1,
        name: 'file',
        postAction: process.env.API + 'upload/post',
        putAction: '',
        headers: {
          // 'X-Csrf-Token': 'xxxx',
          Authorization: 'Basic xxx'
        },
        data: {
          _csrf_token: 'xxxxxx'
        },

        autoCompress: 1024 * 1024,
        uploadAuto: false,

        editFile: {
          show: false,
          name: ''
        },

        requestRoles: [
          {
            value: 'analizat',
            label: 'Debitor'
          },
          {
            value: 'analizat_cf',
            label: 'Debitor - Cash Flow'
          },
          {
            value: 'analizat_bs',
            label: 'Debitor - Bilant'
          },

          {
            value: 'coanalizat',
            label: 'Co-analizat'
          },

          {
            value: 'cf1',
            label: 'Co-analizat 1 - Cash Flow'
          },
          {
            value: 'bs1',
            label: 'Co-analizat 1 - Bilant'
          },

          {
            value: 'cf2',
            label: 'Co-analizat 2 - Cash Flow'
          },
          {
            value: 'bs2',
            label: 'Co-analizat 2 - Bilant'
          },

          {
            value: 'cf3',
            label: 'Co-analizat 3 - Cash Flow'
          },
          {
            value: 'bs3',
            label: 'Co-analizat 3 - Bilant'
          },

          {
            value: 'cf4',
            label: 'Co-analizat 4 - Cash Flow'
          },
          {
            value: 'bs4',
            label: 'Co-analizat 4 - Bilant'
          },

          {
            value: 'cf5',
            label: 'Co-analizat 5 - Cash Flow'
          },
          {
            value: 'bs5',
            label: 'Co-analizat 5 - Bilant'
          }
        ]
      }
    },

    methods: {
      run (onCompleteCallback, onCancelCallback) {
        this.onCompleteCallback = onCompleteCallback
        this.onCancelCallback = onCancelCallback
        this.props = this.requestProperties
        this.files = []
        this.propValues = {}
        this.is_uploading = false

        this.open = true
      },

      onCancel () {
        if (!this.is_uploading) {
          this.open = false
          return
        }

        let ask = false
        for (const f of this.files) {
          if (f.error || f.success) {
            continue
          } else {
            ask = true
            break
          }
        }
        if (ask) {
          this.$alert({
            type: 'info',
            title: 'Pending uploads',
            content: 'Not all files were uploaded, continue?\r\nThis will not however stop the upload',
            showCancel: true,
            cancelText: 'No',
            continueText: 'Yes',
            onConfirm: () => {
              this.open = false
            },
            onCancel: () => {
              // do something..
              // if you want to stop closing alert, just return false
            }
          })
        } else {
          this.open = false
        }
      },

      async onContinue () {
        if (this.is_uploading) {
          return
        }

        // let messages = []
        let error = ''
        for (const p of this.props) {
          if (p.is_mandatory && p.is_visible &&
            (this.propValues[p.property_code] == null || this.propValues[p.property_code] === '')) {
            error = 'Please specify all required properties'
          }
        }

        if (error === '') {
          if (this.files.length === 0) {
            error = 'Please select at least one file'
          }
        }

        if (error === '') {
          error = await this._validateFileRoles()
        }

        if (error !== '') {
          this.$snotify.error(error, {
            position: 'centerTop',
            timeout: 6000,
            showProgressBar: false
          })

          return
        }

        try {
          this.is_uploading = true
          await this._upload()
          // this.open = false
          // this.is_uploading = false
        } catch (e) {
          this.is_uploading = false
          console.log('Error while uploading batch', e)
          this.$snotify.error('An error occured while uploading the files to the server', {
            position: 'centerTop',
            timeout: 6000,
            showProgressBar: false
          })
        }
      },

      async _createBatch () {
        let batchId = batches.uuidv4()
        let batchDetails = []

        let pr = {}
        for (const p of this.props) {
          if (p.is_visible && p.allows_manual_input) {
            pr[p.property_code] = this.propValues[p.property_code]
          }
        }

        for (const f of this.files) {
          let roles = f['role'].split(',')
          f.data['request_id'] = batches.uuidv4()
          batchDetails.push({
            'batch_id': batchId,
            'batch_detail_id': batches.uuidv4(),
            'client_request_id': f.data['request_id'],
            'properties': {
              'roles': roles
            }
          })
        }

        let re = {
          'batch_id': batchId,
          'batch_type': 'MULTIPROC',
          'batch_name': 'Formular.multiprocesare',
          'properties': pr,
          'details': batchDetails
        }
        await batches.createBatch(this.clientCode, re)
      },

      async _upload () {
        await this._createBatch()

        for (const f of this.files) {
          for (const p of this.props) {
            if (p.is_visible && p.allows_manual_input) {
              f.data[p.property_code] = this.propValues[p.property_code]
            }
          }
          // mark this is part of a batch
          f.data['belongs_to_batch'] = 'true'
          f.data['client'] = this.clientCode

          f.headers['Authorization'] = `Bearer ${this.$auth.getAccessToken()}`
          this.$refs.multiproc_upload.update(f.id, {active: true})
        }
      },

      async _validateFileRoles () {
        // at least one main company
        let roles = []
        for (const f of this.files) {
          roles.push(f['role'])
        }
        let r = await axios.post(`${process.env.API}${this.clientCode}/custom/batches/validate-request-roles`, roles)
        console.log(r)
        if (r.data['result'] === 'ok') {
          for (let i = 0; i < this.files.length; i++) {
            this.files[i]['role'] = r.data['data'][i]
          }
          return ''
        } else {
          return r.data['message']
        }
      },

      _updateRole (file) {
        let input = file.name
        let output = input.substr(0, input.lastIndexOf('.')) || input
        output = output.toLowerCase()
          .replace('.', ' ')
          .replace('-', ' ')
          .replace('_', ' ')
        let role = 'coanalizat'
        if (output.endsWith('debitor')) {
          role = 'analizat'
        } else if (output.endsWith('debitor bs')) {
          role = 'analizat_bs'
        } else if (output.endsWith('debitor cf')) {
          role = 'analizat_cf'
        } else if (output.endsWith('cf1')) {
          role = 'cf1'
        } else if (output.endsWith('bs1')) {
          role = 'bs1'
        } else if (output.endsWith('cf2')) {
          role = 'cf2'
        } else if (output.endsWith('bs2')) {
          role = 'bs2'
        } else if (output.endsWith('cf3')) {
          role = 'cf3'
        } else if (output.endsWith('bs3')) {
          role = 'bs3'
        } else if (output.endsWith('cf4')) {
          role = 'cf4'
        } else if (output.endsWith('bs4')) {
          role = 'bs4'
        } else if (output.endsWith('cf5')) {
          role = 'cf5'
        } else if (output.endsWith('bs4')) {
          role = 'bs5'
        }
        file['role'] = role
      },

      inputFile (newFile, oldFile) {
        if (newFile) {
          newFile.headers['Authorization'] = `Bearer ${this.$auth.getAccessToken()}`
          this._updateRole(newFile)
        }

        // // Automatically activate upload
        // if (
        //   Boolean(newFile) !== Boolean(oldFile) ||
        //   oldFile.error !== newFile.error
        // ) {
        //   if (this.uploadAuto && !this.$refs._multiproc_upload.active) {
        //     this.$refs._multiproc_upload.active = true
        //   }
        // }
      },

      inputFilter (newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file

          // Filter system files or hide files
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }

          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }

        if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
          // Create a blob field
          newFile.blob = ''
          let URL = window.URL || window.webkitURL
          if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file)
          }
        }
      },

      enumValues (vals) {
        let s = vals.substring(5)
        let v = s.split('|')
        let ret = []
        for (const sv of v) {
          ret.push({
            value: sv,
            label: sv
          })
        }

        return ret
      },

      reqIndicator (prop) {
        if (prop.is_mandatory) {
          return '(required)'
        }
        return ''
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Clients/Btmic/BatchMultiproc.vue